import isAfter from 'date-fns/isAfter';
import {
  PrivateProfile,
  Profile,
  PublicConfig,
  ReadonlyProfile,
  StoreFront,
  StoreType,
} from '../../models/ClientModels';
import { WithID } from '../firebase/rxfireExtensions';
import { isSellerProfile } from '../models/profiles';

export const usePslPay = (
  profile: WithID<Profile> | null | undefined,
  privateProfile: WithID<PrivateProfile> | null | undefined,
  readonlyProfile: WithID<ReadonlyProfile> | null | undefined,
  store: WithID<StoreFront> | null | undefined,
  publicConfig: Partial<PublicConfig>,
) => {
  const isCreator =
    profile != null &&
    isSellerProfile(profile) &&
    profile.storeType === StoreType.Creator;

  const pslPay = isCreator ? undefined : privateProfile?.pslPay;

  const isPslPayConnected = Boolean(pslPay?.connected && !isCreator);

  // the date after which the psl pay remind should take effect
  const pslPayRemindAfter = publicConfig.psl_pay_remind_after?.toDate();

  // the date after which the psl pay is enforced for all sellers
  const pslPayEnforcedAfter = publicConfig.psl_pay_enforced_after?.toDate();

  const sellerCreatedAt = store?.createdAt.toDate();

  const isPslPayEnabled = Boolean(
    readonlyProfile?.features?.stripeConnect && !isCreator,
  );
  const isNewSeller =
    sellerCreatedAt != null &&
    pslPayRemindAfter != null &&
    isAfter(sellerCreatedAt, pslPayRemindAfter);

  // the psl pay is enforced if:
  // - the seller is signed up after the given date, or
  // - the psl pay enforce date is set and the current time is right after
  //   the psl pay enforce date.
  const isPslPayEnforced = isCreator
    ? false
    : isPslPayEnabled &&
      (isNewSeller ||
        (pslPayEnforcedAfter != null &&
          isAfter(new Date(), pslPayEnforcedAfter)));

  // the psl pay setup remind should be displayed if psl pay is
  // enabled but the seller has not signed up
  const shouldRemindPslPaySetup = isCreator
    ? false
    : isPslPayEnabled && !isPslPayConnected && !isNewSeller;

  return {
    isPslPayConnected,
    isPslPayEnforced,
    shouldRemindPslPaySetup,
    isPslPayEnabled,
  };
};
